import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="not-found">
      <h1 className="not-found-code">404</h1>
      <p className="not-found-message">Page not found</p>
      <Link to="/" className="not-found-button">
        Go to Dashboard
      </Link>
    </div>
  );
}
